import domWrap from "../utils/domWrap";

export default async container => { // 'comp-footer-actions'
	let containerElement = domWrap(container),
		trigger = 0,
		triggerTop = 0,
		fixed = false,
		hidden = true,
		buttons = container.querySelector(':scope > div'),
		truckHero = document.querySelector('comp-truck-hero');

	window.addEventListener('resize',findTrigger);
	window.addEventListener('scroll',scrollCheck);
	findTrigger();
	scrollCheck();
	setInterval(findTrigger,1000);
	
	function findTrigger(){
		trigger = containerElement.offset().top + ((container.offsetHeight / 2) + (buttons.offsetHeight / 2)) - window.innerHeight;
		triggerTop = truckHero ? domWrap(truckHero).offset().top + (truckHero.offsetHeight / 2) : 0;
	}	

	function scrollCheck(e){
		var scrollTop = window.scrollY,
			makeFixed = scrollTop < trigger,
			makeHidden = scrollTop < triggerTop;
		//console.log(scrollTop, trigger);
		if(makeFixed !== fixed){
			fixed = makeFixed;
			buttons.classList.toggle('fixed',fixed);
		}
		if(makeHidden !== hidden){
			hidden = makeHidden;
			buttons.classList.toggle('visible',!hidden);
		}
	}
};